import { Grid, Paper, Popover, Progress, Text } from '@mantine/core'
import { FC } from 'react'
import round from 'lodash-es/round'
import Ellipsis from '../../Ellipsis'
import { NavigationDataResponse } from '@/api/navigationApi/types.gen'

const PatrolProgress: FC<{
  navigationData?: NavigationDataResponse
}> = ({ navigationData }) => {
  if (!navigationData) return null

  const progress = round((navigationData.route_progress || 0) * 100)
  const routeId = navigationData.drive_data?.route_id
  const moduleState = navigationData.route_module_state
  const displayProgress = moduleState === 'Driving' && navigationData.drive_data && navigationData.is_freeride !== true

  return (
    displayProgress && (
      <Grid
        align="stretch"
        style={{
          position: 'absolute',
          bottom: 10,
          left: 20,
          right: 20,
          zIndex: 1000,
          borderRadius: '8px',
        }}
      >
        <Grid.Col span={3}>
          <Popover position="top-start">
            <Popover.Target>
              <Paper shadow="xs" p="md" radius="sm" styles={{ root: { minHeight: '100%' } }} withBorder>
                <Ellipsis>{routeId || ''}</Ellipsis>
              </Paper>
            </Popover.Target>
            <Popover.Dropdown>
              <Text size="xl" fw="bold">
                {routeId}
              </Text>
            </Popover.Dropdown>
          </Popover>
        </Grid.Col>
        <Grid.Col span={6}>
          <Paper
            shadow="xs"
            p="md"
            radius="sm"
            styles={{ root: { minHeight: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' } }}
            withBorder
          >
            <Progress value={progress} color="violet" radius="sm" size="xl" />
          </Paper>
        </Grid.Col>
        <Grid.Col span={3}>
          <Paper
            shadow="xs"
            p="md"
            radius="sm"
            styles={{ root: { textAlign: 'center', minHeight: '100%' } }}
            withBorder
          >
            <Text fz={32} fw="bold" styles={{ root: { lineHeight: 'unset' } }}>
              {progress} %
            </Text>
          </Paper>
        </Grid.Col>
      </Grid>
    )
  )
}

export default PatrolProgress
